/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import { defineNuxtPlugin, useHead, useRuntimeConfig } from 'nuxt/app'

const _layer = 'dataLayer'

function gtmClient() {
  return {
    push(obj) {
      if (!window[_layer]) {
        window[_layer] = []
      }
      window[_layer].push(obj)
    },
  }
}

function gtmServer() {
  const events: any[] = []
  return {
    push(obj: any) {
      events.push(obj)
    },
    unshift(obj: any) {
      events.unshift(obj)
    },
    render(gtmId: string) {
      let script =
        'window.gmo = window.gmo || {}; window.dataLayer = window.dataLayer || [];'
      while (events.length) {
        const event = events.shift()
        script += `${_layer}.push(${JSON.stringify(event)});`
      }
      useHead({
        script: [
          {
            id: 'data-layer',
            innerHTML: script,
          },
          {
            id: 'gtm-script',
            innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'/_metrics/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
          },
        ],
      })
    },
  }
}

function startPageTracking(gtm) {
  const router = useRouter()
  const runtimeConfig = useRuntimeConfig()
  router.afterEach((to) => {
    setTimeout(() => {
      gtm.push(
        to.meta.gtm || {
          routeName: to.name,
          pageType: 'PageView',
          pageUrl: runtimeConfig.public.envUrl + to.fullPath,
          pageTitle: (typeof document !== 'undefined' && document.title) || '',
          event: 'nuxtRoute',
        },
      )
    }, 250)
  })
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const gtm = process.client ? gtmClient() : gtmServer()

  // Make GTM available to Vue instance
  Object.defineProperty(nuxtApp.vueApp.config.globalProperties, '$gtm', {
    value: gtm,
    writable: false,
    configurable: true,
    enumerable: true,
  })

  gtm.push({
    isSSR: process.server,
  })

  if (process.server) {
    nuxtApp.hooks.hook('app:rendered', () => {
      const gtmServer = gtm as ReturnType<typeof gtmServer>
      gtmServer.unshift({
        alfredVersion: config.public.alfredVersion,
        config: config.public,
        event: 'appInit',
      })
      if (config.public.gtm && config.public.gtm.id && gtmServer.render) {
        gtmServer.render(config.public.gtm.id)
      }
    })
  }
  startPageTracking(gtm)
  return {
    provide: {
      gtm,
    },
  }
})
